import markLight from "@/assets/mark-light.svg";

type Size = "sm" | "md" | "lg" | "xl";

type Props = {
  size?: Size;
};

const config: Record<
  Size,
  {
    mark: string;
    dividerH: string;
    ml: string;
    mr: string;
    momentum: string;
    peaks: string;
  }
> = {
  sm: {
    mark: "w-9 h-9",
    dividerH: "h-5",
    ml: "ml-1.5",
    mr: "mr-3",
    momentum: "text-base font-bold leading-none",
    peaks: "text-[9px] font-medium leading-none tracking-[0.32em]",
  },
  md: {
    mark: "w-11 h-11",
    dividerH: "h-6",
    ml: "ml-2",
    mr: "mr-3.5",
    momentum: "text-lg font-bold leading-none",
    peaks: "text-[10px] font-medium leading-none tracking-[0.36em]",
  },
  lg: {
    mark: "w-16 h-16",
    dividerH: "h-8",
    ml: "ml-2",
    mr: "mr-4",
    momentum: "text-2xl font-bold leading-none",
    peaks: "text-xs font-medium leading-none tracking-[0.42em]",
  },
  xl: {
    mark: "w-20 h-20",
    dividerH: "h-10",
    ml: "ml-2.5",
    mr: "mr-5",
    momentum: "text-3xl font-bold leading-none",
    peaks: "text-sm font-medium leading-none tracking-[0.48em]",
  },
};

export function BrandLockup({ size = "md" }: Props) {
  const c = config[size];

  return (
    <span className="inline-flex items-center">
      <img
        src={markLight}
        alt=""
        aria-hidden="true"
        className={`${c.mark} shrink-0`}
      />
      <span
        className={`${c.ml} ${c.mr} ${c.dividerH} w-px shrink-0 bg-[#a7b6b1]`}
        aria-hidden="true"
      />
      <span
        className="flex flex-col gap-1"
        style={{ fontFamily: "'Rajdhani', sans-serif" }}
      >
        <span className={`${c.momentum} uppercase tracking-[0.055em] text-[#102a25]`}>
          MOMENTUM
        </span>
        <span className="flex items-center gap-2">
          <span className={`${c.peaks} uppercase text-[#006b5f]`}>PEAKS</span>
          <span className="h-px w-3 bg-[#8aa29a]" aria-hidden="true" />
          <span className="text-[7px] font-bold uppercase leading-none tracking-[0.16em] text-[#60716c]">
            ENDURANCE
          </span>
        </span>
      </span>
    </span>
  );
}
